import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation, useQuery } from "@tanstack/react-query";

import { SaveButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error } from "ui-components/Alert";
import { formRender, initialValues, coReturnCodeValidation } from "./co-return-code-schema";
import { getCOReturnCode, editCOReturnCode } from "services/data.internal.service";
import COReturnCodeInfo from "./components/COReturnCodeInfo";
import { useLocation } from "react-router-dom";

function EditCOReturnCode() {
  const location = useLocation();
  const { returnCode } = location.state;
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState(null)
  const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);

  useQuery({
    queryKey: ["co-return-code", { returnCode }],
    queryFn: () => getCOReturnCode({ returnCode }),
    onSuccess: (data) => setFormValues(data.data.data),
    onError,
  });

  const editCOReturnCodeMutation = useMutation(editCOReturnCode, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    values:formValues,
    resolver: yupResolver(coReturnCodeValidation),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty, isSubmitting },
    setValue,
    reset,
  } = form;

  const infoProps = {
    mode: "EDIT",
    control,
    errors,
    setValue,
    formRender,
  };
  const onSubmit = (data) => {
    editCOReturnCodeMutation.mutate(data, {
      onSuccess: () => {
      },
    });
  };
  const editStatus = editCOReturnCodeMutation.status === "loading";
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <COReturnCodeInfo {...infoProps} />
        <SaveButton label="Save" disabled={!isDirty && editStatus} url="/setup/return-code" />
      </form>
    </Layout>
  );
}

export default EditCOReturnCode;
